




import Vue from 'vue'

export default Vue.extend({
  name: 'SvgElement',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    svg() {
      return () => import(`@/assets/svgs/${this.name}.svg`)
    },
  },
})
